module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0095.jpg?v=e028d25f";